<template>
    <div class="assessment-page">
        <!-- 筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-s-data"></i>
                    <span>学生测评管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选学生</span>
                </div>
            </div>
            <el-form :inline="true" :model="filterForm" class="filter-form">
                <el-form-item label="年级">
                    <el-select v-model="filterForm.gradeId" placeholder="请选择年级" clearable @change="handleGradeChange" style="width: 150px">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="filterForm.classId" placeholder="请选择班级" clearable :disabled="!filterForm.gradeId" style="width: 150px">
                        <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="filterForm.nickname" placeholder="请输入姓名" clearable style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input v-model="filterForm.studentNo" placeholder="请输入学号" clearable style="width: 150px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="loadStudents">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>


        <!-- 内容区域 -->
        <el-card shadow="always" class="table-card">
            <el-row :gutter="20">
                <!-- 左侧：学生列表 -->
                <el-col :span="7">
                    <div class="student-list-container">
                        <div class="list-header">
                            <h3>学生列表</h3>
                            <span class="count-badge">{{ studentList.length }}</span>
                        </div>

                        <el-scrollbar style="height: calc(100vh - 280px);">
                            <div
                                v-for="student in studentList"
                                :key="student.id"
                                class="student-card"
                                :class="{ 'active': selectedStudent && selectedStudent.id === student.id }"
                                @click="handleStudentSelect(student)">
                                <div class="student-avatar" :style="{ background: getAvatarColor(student.id) }">
                                    {{ getAvatarText(student.nickname || student.username) }}
                                </div>
                                <div class="student-info">
                                    <div class="student-name">{{ student.nickname || student.userName }}</div>
                                    <div class="student-meta">
                                        <span class="meta-item">
                                            <i class="el-icon-collection-tag"></i>
                                            {{ student.gradeName || '未知年级' }}
                                        </span>
                                        <span class="meta-divider">|</span>
                                        <span class="meta-item">
                                            <i class="el-icon-school"></i>
                                            {{ student.className || '未知班级' }}
                                        </span>
                                    </div>
                                    <div class="student-meta student-meta-secondary">
                                        <span class="meta-item" :class="{ 'meta-warn': student.count != null && student.count < 5 }">
                                            <i class="el-icon-document"></i>
                                            试卷 {{ student.count != null ? student.count : '-' }} 套
                                        </span>
                                        <span class="meta-divider">|</span>
                                        <span class="meta-item" :class="{ 'meta-warn': student.classHours != null && student.classHours < 5 }">
                                            <i class="el-icon-time"></i>
                                            课时 {{ student.classHours != null ? student.classHours : '-' }}
                                        </span>
                                    </div>
                                </div>
                                <i class="el-icon-arrow-right card-arrow"></i>
                            </div>

                            <el-empty
                                v-if="studentList.length === 0"
                                description="暂无学生数据"
                                :image-size="80">
                            </el-empty>
                        </el-scrollbar>
                    </div>
                </el-col>

                <!-- 右侧：试卷管理区域 -->
                <el-col :span="17">
                    <div v-if="!selectedStudent" class="empty-state">
                        <el-empty description="请从左侧选择一个学生"></el-empty>
                    </div>

                    <div v-else class="paper-management">
                        <!-- 学生信息卡片 -->
                        <div class="student-info-bar">
                            <div class="student-info-avatar" :style="{ background: getAvatarColor(selectedStudent.id) }">
                                {{ getAvatarText(selectedStudent.nickname || selectedStudent.username || selectedStudent.userName) }}
                            </div>
                            <div class="student-info-content">
                                <div class="info-name">{{ selectedStudent && (selectedStudent.nickname || selectedStudent.userName) }}</div>
                                <div class="info-row">
                                    <span class="info-tag"><i class="el-icon-document"></i>{{ selectedStudent && selectedStudent.studentNo || '未设置' }}</span>
                                    <span class="info-tag"><i class="el-icon-collection-tag"></i>{{ selectedStudent && selectedStudent.gradeName || '未知年级' }}</span>
                                    <span class="info-tag"><i class="el-icon-school"></i>{{ selectedStudent && selectedStudent.className || '未知班级' }}</span>
                                </div>
                            </div>
                            <div class="student-info-stats">
                                <div class="stat-item">
                                    <span class="stat-value" :class="{ 'stat-warn': selectedStudent && selectedStudent.count != null && selectedStudent.count < 5 }">{{ selectedStudent && selectedStudent.count != null ? selectedStudent.count : '-' }}</span>
                                    <span class="stat-label">剩余试卷</span>
                                </div>
                                <div class="stat-divider"></div>
                                <div class="stat-item">
                                    <span class="stat-value" :class="{ 'stat-warn': selectedStudent && selectedStudent.classHours != null && selectedStudent.classHours < 5 }">{{ selectedStudent && selectedStudent.classHours != null ? selectedStudent.classHours : '-' }}</span>
                                    <span class="stat-label">剩余课时</span>
                                </div>
                            </div>
                        </div>

                        <!-- 操作按钮 -->
                        <div class="action-bar">
                            <el-button type="primary" size="small" icon="el-icon-plus" @click="showGenerateDialog">生成新试卷</el-button>
                            <el-button size="small" icon="el-icon-refresh" @click="loadPaperList">刷新</el-button>
                        </div>

                        <!-- 试卷筛选 -->
                        <div class="paper-filter-bar">
                            <el-date-picker
                                v-model="paperSearchDate"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                value-format="yyyy-MM-dd"
                                style="width:246px;">
                            </el-date-picker>
                            <el-select v-model="paperSearchStatus" placeholder="状态筛选" size="small" clearable style="width:130px;">
                                <el-option
                                    v-for="s in statusList"
                                    :key="s.code"
                                    :label="s.desc"
                                    :value="s.code">
                                </el-option>
                            </el-select>
                            <el-button type="primary" size="small" icon="el-icon-search" @click="searchPapers">查询</el-button>
                            <el-button size="small" icon="el-icon-refresh-left" @click="resetPaperFilter">重置</el-button>
                        </div>

                        <!-- 试卷列表 -->
                        <div class="paper-list-container">
                            <div class="paper-list-header">
                                <h3>试卷列表</h3>
                                <span class="total-badge">共 <b>{{ paperTotal }}</b> 条</span>
                            </div>
                            <el-table
                                :data="paperList"
                                border
                                stripe
                                v-loading="paperLoading"
                                element-loading-text="加载中..."
                                style="width: 100%"
                                @expand-change="handleExpandChange">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <div class="paper-detail-preview">
                                            <div class="detail-grid">
                                                <div class="detail-item">
                                                    <span class="label">试卷编号</span>
                                                    <span class="val">{{ props.row.paperNo || '-' }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="label">试卷标题</span>
                                                    <span class="val">{{ props.row.paperTitle || '默认试卷' }}</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="label">总题数</span>
                                                    <span class="val">{{ props.row.totalWords || '-' }} 题</span>
                                                </div>
                                                <div class="detail-item">
                                                    <span class="label">总分</span>
                                                    <span class="val">{{ props.row.totalScore || '-' }} 分</span>
                                                </div>
                                                <div class="detail-item" v-if="props.row.score != null">
                                                    <span class="label">得分</span>
                                                    <span class="val" :class="scoreClass(props.row)">{{ props.row.score }} 分</span>
                                                </div>
                                                <div class="detail-item" v-if="props.row.correctCount != null">
                                                    <span class="label">正确/错误</span>
                                                    <span class="val">
                                                        <span class="correct">{{ props.row.correctCount }} 正确</span>
                                                        /
                                                        <span class="wrong">{{ props.row.wrongCount }} 错误</span>
                                                    </span>
                                                </div>
                                                <div class="detail-item" v-if="props.row.durationMinutes">
                                                    <span class="label">考试时长</span>
                                                    <span class="val">{{ props.row.durationMinutes }} 分钟</span>
                                                </div>
                                                <div class="detail-item" v-if="props.row.passingScore">
                                                    <span class="label">及格线</span>
                                                    <span class="val">{{ props.row.passingScore }} 分</span>
                                                </div>
                                                <div class="detail-item" v-if="props.row.questionTypes">
                                                    <span class="label">包含题型</span>
                                                    <span class="val">
                                                        <span
                                                            v-for="(type, idx) in props.row.questionTypes.split(', ')"
                                                            :key="idx"
                                                            class="type-tag"
                                                            :class="'type-color-' + ((idx % 5) + 1)">
                                                            {{ type }}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="试卷信息" min-width="200">
                                    <template slot-scope="scope">
                                        <div class="paper-info-cell">
                                            <div class="paper-title">{{ scope.row.paperTitle || '默认试卷' }}</div>
                                            <div class="paper-meta">
                                                <span class="meta-tag">#{{ scope.row.paperNo || scope.row.id }}</span>
                                            </div>
                                            <div class="paper-types" v-if="scope.row.questionTypes">
                                                <span
                                                    v-for="(type, idx) in scope.row.questionTypes.split(', ')"
                                                    :key="idx"
                                                    class="type-tag"
                                                    :class="'type-color-' + ((idx % 5) + 1)">
                                                    {{ type }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态" width="100">
                                    <template slot-scope="scope">
                                        <el-tag :type="getStatusType(scope.row.paperStatus)" effect="dark" size="medium">
                                            {{ getStatusText(scope.row.paperStatus) }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="原因" min-width="160">
                                    <template slot-scope="scope">
                                        <div v-if="getMissingSummary(scope.row.missingInfo)" class="missing-reason-cell">
                                            <i class="el-icon-warning-outline"></i>
                                            <span>{{ getMissingSummary(scope.row.missingInfo) }}</span>
                                        </div>
                                        <span v-else class="no-score">-</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="得分" width="100" v-if="hasGradedPaper">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.score != null" :class="scoreClass(scope.row)" class="score-value">
                                            {{ scope.row.score }}
                                        </span>
                                        <span v-else class="no-score">-</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="创建时间" width="170">
                                    <template slot-scope="scope">
                                        <div class="time-cell">
                                            <i class="el-icon-time"></i>
                                            {{ formatTime(scope.row.createTime) }}
                                        </div>
                                    </template>
                                </el-table-column>
<!--                                <el-table-column label="提交/批改" width="170">-->
<!--                                    <template slot-scope="scope">-->
<!--                                        <div class="time-cell" v-if="scope.row.submitTime">-->
<!--                                            <span class="time-label">提交</span>-->
<!--                                            {{ formatTime(scope.row.submitTime) }}-->
<!--                                        </div>-->
<!--                                        <div class="time-cell" v-if="scope.row.gradeTime">-->
<!--                                            <span class="time-label">批改</span>-->
<!--                                            {{ formatTime(scope.row.gradeTime) }}-->
<!--                                        </div>-->
<!--                                        <span v-if="!scope.row.submitTime && !scope.row.gradeTime" class="no-score">-</span>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <el-table-column label="二维码" width="80" align="center">
                                    <template slot-scope="scope">
                                        <el-popover
                                            placement="left"
                                            trigger="click"
                                            :width="180"
                                            v-if="scope.row.qrCodeUrl">
                                            <img :src="scope.row.qrCodeUrl" style="width:160px;height:160px;display:block;" alt="二维码"/>
                                            <el-button slot="reference" size="mini" type="text" icon="el-icon-full-screen" circle></el-button>
                                        </el-popover>
                                        <span v-else class="no-score">-</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="320" fixed="right">
                                    <template slot-scope="scope">
                                        <div class="action-btns">
                                            <!-- 学案详情 -->
                                            <el-tooltip content="查看学案详情" placement="top">
                                                <el-button size="mini" type="success" icon="el-icon-view"
                                                    :disabled="![1,3,4,5].includes(scope.row.paperStatus)"
                                                    @click="viewPaperDetail(scope.row.id)">详情</el-button>
                                            </el-tooltip>

                                            <!-- 下载 -->
                                            <el-tooltip :content="getActionTip('download', scope.row.paperStatus)"
                                                :disabled="[1,4,5].includes(scope.row.paperStatus)" placement="top">
                                                <el-button size="mini" type="primary" icon="el-icon-download"
                                                    :disabled="![1,4,5].includes(scope.row.paperStatus)"
                                                    @click="downloadPaper(scope.row.id)">下载</el-button>
                                            </el-tooltip>

                                            <!-- 更多：学习二维码 + 试题详情 -->
                                            <el-dropdown trigger="click" @command="(cmd) => handlePaperCommand(cmd, scope.row)">
                                                <el-button size="mini">
                                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                                </el-button>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item command="qrcode" icon="el-icon-reading">学习二维码</el-dropdown-item>
                                                    <el-dropdown-item command="detail"
                                                        :disabled="![1,3,4].includes(scope.row.paperStatus)"
                                                        icon="el-icon-view">学案详情</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>

                                            <!-- 下载 -->
                                            <el-tooltip :content="getActionTip('download', scope.row.paperStatus)"
                                                :disabled="[1,4].includes(scope.row.paperStatus)" placement="top">
                                                <el-button size="mini" type="primary" icon="el-icon-download"
                                                    :disabled="![1,4].includes(scope.row.paperStatus)"
                                                    @click="downloadPaper(scope.row.id)">下载</el-button>
                                            </el-tooltip>

                                            <!-- 分析：答题分析 + 回退 -->
                                            <el-dropdown trigger="click" @command="(cmd) => handlePaperCommand(cmd, scope.row)">
                                                <el-button size="mini">
                                                    分析<i class="el-icon-arrow-down el-icon--right"></i>
                                                </el-button>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item command="analysis"
                                                        :disabled="![1,3,4].includes(scope.row.paperStatus)"
                                                        icon="el-icon-document-copy">答题分析</el-dropdown-item>
                                                    <el-dropdown-item command="rollback"
                                                        :disabled="scope.row.paperStatus !== 4"
                                                        icon="el-icon-refresh-left">回退</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>

                                            <!-- 删除（红色标注） -->
                                            <el-tooltip :content="getActionTip('delete', scope.row.paperStatus)"
                                                :disabled="[1,2,5].includes(scope.row.paperStatus)" placement="top">
                                                <el-button size="mini" type="danger" icon="el-icon-delete"
                                                    :disabled="![1,2,5].includes(scope.row.paperStatus)"
                                                    @click="deletePaper(scope.row.id)">删除</el-button>
                                            </el-tooltip>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-pagination
                                v-if="paperTotal > 0"
                                style="margin-top: 16px;"
                                background
                                layout="total, sizes, prev, pager, next, jumper"
                                :page-sizes="[10, 20, 50]"
                                @size-change="handlePaperSizeChange"
                                @current-change="handlePaperPageChange"
                                :current-page="paperCurrentPage"
                                :page-size="paperPageSize"
                                :total="paperTotal">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 生成试卷对话框 -->
        <el-dialog
            title="生成新试卷"
            :visible.sync="generateDialogVisible"
            width="900px"
            :close-on-click-modal="false">
            <div v-if="generateStep === 1">
                <el-alert
                    title="为学生生成新的测评试卷"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 20px;">
                </el-alert>

                <div class="generate-info">
                    <div class="info-grid">
                        <div class="info-item">
                            <span class="label">学生</span>
                            <span class="val">{{ selectedStudent && (selectedStudent.nickname || selectedStudent.userName) }}</span>
                        </div>
                        <div class="info-item">
                            <span class="label">年级</span>
                            <span class="val">{{ selectedStudent && (selectedStudent.gradeName || '未知') }}</span>
                        </div>
                        <div class="info-item">
                            <span class="label">班级</span>
                            <span class="val">{{ selectedStudent && (selectedStudent.className || '未知') }}</span>
                        </div>
                        <div class="info-item">
                            <span class="label">学号</span>
                            <span class="val">{{ selectedStudent && studentNoDisplay }}</span>
                        </div>
                        <div class="info-item">
                            <span class="label">剩余试卷</span>
                            <span class="val">{{ studentPaperCount }} 套</span>
                        </div>
                        <div class="info-item">
                            <span class="label">单词数</span>
                            <span class="val">8 个（固定）</span>
                        </div>
                    </div>
                </div>

                <!-- 题型选择 -->
                <div class="type-selection-section">
                    <div class="section-header">
                        <h4>选择题型</h4>
                        <span class="selection-info">
                            前4项为固定题型，已自动勾选
                        </span>
                    </div>
                    <div class="type-chips">
                        <div
                            v-for="item in questionTypes"
                            :key="item.code"
                            class="type-chip"
                             :class="{
                                'selected': isTypeSelected(item.code),
                                'fixed': item.code <= 4
                            }"
                            @click="toggleType(item)">
                            <span class="type-code">{{ item.code }}</span>
                            <span class="type-desc">{{ item.desc }}</span>
                            <el-tag v-if="!item.aiGenerated" size="mini" type="info" effect="plain">内置</el-tag>
                            <el-tag v-else size="mini" type="warning" effect="plain">AI</el-tag>
                            <span class="type-count-input" v-if="isTypeSelected(item.code)">
                                <span class="count-label">题数：</span>
                                <el-input-number
                                    size="mini"
                                    :min="1"
                                    :max="10"
                                    :disabled="item.code <= 3"
                                    v-model="getTypeConfig(item.code).count"
                                    @click.native.stop
                                    @change="(val) => updateTypeCount(item.code, val)">
                                </el-input-number>
                            </span>
                            <span class="check-placeholder">
                                <i v-if="isTypeSelected(item.code) && item.code > 4" class="el-icon-check"></i>
                                <i v-else-if="isTypeSelected(item.code) && item.code <= 4" class="el-icon-lock"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <!-- 单词列表展示 -->
                <div class="word-selection-section" v-loading="loadingWords">
                    <div class="section-header">
                        <h4>待练习单词列表（共 {{ pendingWords.length }} 个）</h4>
                        <div class="selection-info">
                            已选择 <span class="count-highlight">{{ selectedWordIds.length }}</span> / 8 个单词
                        </div>
                    </div>

                    <el-table
                        :data="pendingWords"
                        border
                        style="width: 100%; margin-top: 15px;"
                        max-height="400"
                        @selection-change="handleWordSelectionChange">
                        <!-- <el-table-column
                            type="selection"
                            width="55"
                            :selectable="isWordSelectable">
                        </el-table-column> -->
                        <el-table-column type="index" label="序号" width="60"/>
                        <el-table-column prop="unitName" label="单元"/>
                <el-table-column label="册次" width="80">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.volume === 1 ? 'success' : scope.row.volume === 2 ? 'warning' : 'info'" size="small">
                            {{ getVolumeLabel(scope.row.volume) }}
                        </el-tag>
                    </template>
                </el-table-column>
                        <el-table-column prop="word" label="单词" width="120"/>
                        <el-table-column prop="meaning" label="释义" width="200"/>
                        <el-table-column prop="phoneticUk" label="英音音标" width="120"/>
<!--                        <el-table-column prop="phoneticUs" label="美音音标" width="120"/>-->
                        <el-table-column label="状态" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.isMastered ? 'success' : 'info'" size="small">
                                    {{ scope.row.isMastered ? '已掌握' : '待练习' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-alert
                        v-if="pendingWords.length === 0 && !loadingWords"
                        title="暂无可练习的单词"
                        type="warning"
                        :closable="false"
                        show-icon
                        style="margin-top: 15px;">
                    </el-alert>
                </div>

                <el-alert
                    title="调用AI生成内容可能需要30-60秒，请耐心等待"
                    type="warning"
                    :closable="false"
                    show-icon
                    style="margin-top: 20px;">
                </el-alert>
            </div>

            <div v-if="generateStep === 2" class="generating-step">
                <p>正在生成试卷...</p>
                <el-progress
                    :percentage="generateProgress"
                    :status="generateProgressStatus">
                </el-progress>
                <p class="progress-text">{{ generateProgressText }}</p>
            </div>

            <div slot="footer">
                <el-button v-if="generateStep === 1" @click="generateDialogVisible = false">取消</el-button>
                <el-button
                    v-if="generateStep === 1"
                    type="primary"
                    :loading="generating"
                    @click="confirmGenerate">
                    确认生成
                </el-button>
                <el-button
                    v-if="generateStep === 2"
                    type="primary"
                    @click="generateDialogVisible = false"
                    :disabled="generateProgress < 100">
                    关闭
                </el-button>
            </div>
        </el-dialog>

        <!-- 答题分析弹窗 -->
        <el-dialog
            title="答题分析"
            :visible.sync="analyzeDialogVisible"
            :close-on-click-modal="false"
            @close="handleAnalyzeDialogClose">
            <div v-if="analyzePaper" v-loading="uploading || analysisLoading || screeningLoading">
                <el-alert
                    title="上传学生的答题图片和筛查表图片，支持jpg/png格式。保存后可进行AI分析，支持随时修改图片后重新分析。"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 16px;">
                </el-alert>

                <!-- 答题图片 -->
                <div class="image-section">
                    <div class="image-section-header">
                        <span class="image-section-label">答题图片</span>
                        <span class="image-section-hint" v-if="savedAnswerImages.length > 0">已保存 {{ savedAnswerImages.length }} 张</span>
                    </div>
                    <div v-if="savedAnswerImages.length > 0" class="saved-images-bar">
                        <div class="saved-images-grid">
                            <div v-for="(img, idx) in savedAnswerImages" :key="idx" class="saved-image-item">
                                <el-image :src="img.url" fit="cover" :preview-src-list="answerPreviewList"></el-image>
                                <div v-if="analyzePaper.paperStatus === 1" class="saved-image-remove" @click="removeSavedAnswerImage(idx)">
                                    <i class="el-icon-close"></i>
                                </div>
                            </div>
                        </div>
                    </div>
<el-upload v-if="analyzePaper.paperStatus === 1"
    ref="answerUploader"
    :auto-upload="false"
    list-type="picture-card"
    accept="image/jpeg,image/png,image/jpg"
    multiple
    action="">
    <i class="el-icon-plus"></i>
</el-upload>
                </div>

                <el-divider></el-divider>

                <!-- 筛查表图片 -->
                <div class="image-section">
                    <div class="image-section-header">
                        <span class="image-section-label">筛查表图片</span>
                        <span class="image-section-hint" v-if="savedScreeningImages.length > 0">已保存 {{ savedScreeningImages.length }} 张</span>
                    </div>
                    <div v-if="savedScreeningImages.length > 0" class="saved-images-bar">
                        <div class="saved-images-grid">
                            <div v-for="(img, idx) in savedScreeningImages" :key="idx" class="saved-image-item">
                                <el-image :src="img.url" fit="cover" :preview-src-list="screeningPreviewList"></el-image>
                                <div v-if="analyzePaper.paperStatus === 1" class="saved-image-remove" @click="removeSavedScreeningImage(idx)">
                                    <i class="el-icon-close"></i>
                                </div>
                            </div>
                        </div>
                    </div>
<el-upload v-if="analyzePaper.paperStatus === 1"
    ref="screeningUploader"
    :auto-upload="false"
    list-type="picture-card"
    accept="image/jpeg,image/png,image/jpg"
    multiple
    action="">
    <i class="el-icon-plus"></i>
</el-upload>
                    <div v-if="savedScreeningImages.length === 0 && analyzePaper.paperStatus !== 1" class="upload-placeholder">
                        <i class="el-icon-picture-outline"></i>
                        <span>未上传筛查表图片</span>
                    </div>
                </div>

                <div style="margin: 16px 0;">
                    <el-button v-if="analyzePaper.paperStatus === 1" type="primary" :loading="uploading" @click="saveImages">
                        保存图片
                    </el-button>
                    <span v-if="imagesSaved" style="color: #67c23a; margin-left: 10px;">
                        <i class="el-icon-success"></i> 已保存
                    </span>
                </div>

                <!-- 已生成状态下显示分析按钮 -->
                <template v-if="imagesSaved && (analyzePaper.paperStatus === 1 || analyzePaper.paperStatus === 3)">
                    <el-divider></el-divider>
                    <div style="margin-bottom: 16px;">
                        <el-button type="primary" :loading="analysisLoading" :disabled="screeningLoading" @click="runAnswerAnalysis" size="medium">
                            <i class="el-icon-document-copy"></i> 答题分析
                        </el-button>
                        <el-button type="warning" :loading="screeningLoading" :disabled="analysisLoading" @click="runScreeningAnalysis" size="medium">
                            <i class="el-icon-s-order"></i> 筛查表解析
                        </el-button>
                    </div>
                </template>

                <template v-if="diagnosisData">
                    <el-alert
                        :title="`分析完成：已掌握 ${diagnosisData.masteredCount || 0} 个，未掌握 ${diagnosisData.unmasteredCount || 0} 个`"
                        type="success"
                        :closable="false"
                        show-icon
                        style="margin-bottom: 16px;">
                    </el-alert>
                    <el-tabs type="border-card">
                        <!-- 筛查表标签页：展示单词的掌握情况 -->
                        <el-tab-pane label="筛查表">
                            <!-- 未掌握(勾选) -->
                            <div style="margin-bottom: 16px;">
                                <div class="screening-section-header">
                                    <i class="el-icon-circle-close" style="color:#f56c6c"></i>
                                    <span style="color:#f56c6c; font-weight:600;">未掌握（勾选）</span>
                                    <span class="type-group-count">({{ (diagnosisData.unmasteredWords || []).length }} 个)</span>
                                </div>
                                <el-table :data="diagnosisData.unmasteredWords || []" border size="small" max-height="240">
                                    <el-table-column type="index" label="序号" width="50"/>
                                    <el-table-column prop="word" label="单词" min-width="120"/>
                                    <el-table-column prop="chineseMeaning" label="释义" min-width="150"/>
                                    <el-table-column prop="diagnosisDetail" label="来源" min-width="160"/>
                                    <el-table-column label="操作" width="120" fixed="right">
                                        <template slot-scope="scope">
                                            <el-button type="success" size="mini" @click="toggleWordMastery(scope.row, true)" :loading="togglingWordId === scope.row.wordId" :disabled="analyzePaper.paperStatus === 4">
                                                确认掌握
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-empty v-if="!(diagnosisData.unmasteredWords || []).length" description="暂无未掌握单词" :image-size="50"></el-empty>
                            </div>
                            <!-- 已掌握(未勾选) -->
                            <div>
                                <div class="screening-section-header">
                                    <i class="el-icon-success" style="color:#67c23a"></i>
                                    <span style="color:#67c23a; font-weight:600;">已掌握（未勾选）</span>
                                    <span class="type-group-count">({{ (diagnosisData.masteredWords || []).length }} 个)</span>
                                </div>
                                <el-table :data="diagnosisData.masteredWords || []" border size="small" max-height="240">
                                    <el-table-column type="index" label="序号" width="50"/>
                                    <el-table-column prop="word" label="单词" min-width="120"/>
                                    <el-table-column prop="chineseMeaning" label="释义" min-width="150"/>
                                    <el-table-column prop="diagnosisDetail" label="来源" min-width="160"/>
                                    <el-table-column label="操作" width="120" fixed="right">
                                        <template slot-scope="scope">
                                            <el-button type="danger" size="mini" @click="toggleWordMastery(scope.row, false)" :loading="togglingWordId === scope.row.wordId" :disabled="analyzePaper.paperStatus === 4">
                                                标记未掌握
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-empty v-if="!(diagnosisData.masteredWords || []).length" description="暂无已掌握单词" :image-size="50"></el-empty>
                            </div>
                        </el-tab-pane>
                        <!-- 学情报告标签页 -->
                        <el-tab-pane label="学情报告" v-if="reportData">
                            <div class="report-container">
                                <div class="report-header">
                                    <h2>{{ reportData.studentName || '' }} {{ reportData.reportDate || '' }}学情报告</h2>
                                    <el-button size="small" icon="el-icon-document-copy" @click="copyReport" style="margin-left: auto;">复制</el-button>
                                </div>
                                <el-card shadow="never" class="report-section">
                                    <div class="report-section-title">
                                        <i class="el-icon-star-on" style="color:#e6a23c"></i>
                                        今日学案完成数量：{{ reportData.paperCount || 0 }}套
                                    </div>
                                    <div v-if="reportData.paperTitles && reportData.paperTitles.length" class="report-paper-titles">
                                        <span v-for="(t, i) in reportData.paperTitles" :key="i" class="paper-title-tag">{{ t }}</span>
                                    </div>
                                </el-card>
                                <el-card shadow="never" class="report-section" v-if="reportData.vocabularyAnalysis">
                                    <div class="report-section-title">一、词汇掌握情况</div>
                                    <div class="report-general">{{ reportData.vocabularyAnalysis.general }}</div>
                                    <div v-if="reportData.vocabularyAnalysis.weaknesses && reportData.vocabularyAnalysis.weaknesses.length" class="report-weaknesses">
                                        <div class="weakness-label">不足：</div>
                                        <ul><li v-for="(w, i) in reportData.vocabularyAnalysis.weaknesses" :key="i">{{ w }}</li></ul>
                                    </div>
                                </el-card>
                                <el-card shadow="never" class="report-section" v-if="reportData.wordMeaningAnalysis">
                                    <div class="report-section-title">二、词义理解情况</div>
                                    <div class="report-general">{{ reportData.wordMeaningAnalysis.general }}</div>
                                    <div v-if="reportData.wordMeaningAnalysis.weaknesses && reportData.wordMeaningAnalysis.weaknesses.length" class="report-weaknesses">
                                        <div class="weakness-label">不足：</div>
                                        <ul><li v-for="(w, i) in reportData.wordMeaningAnalysis.weaknesses" :key="i">{{ w }}</li></ul>
                                    </div>
                                </el-card>
                                <el-card shadow="never" class="report-section" v-if="reportData.spellingAnalysis">
                                    <div class="report-section-title">三、单词拼写情况</div>
                                    <div class="report-general">{{ reportData.spellingAnalysis.general }}</div>
                                    <div v-if="reportData.spellingAnalysis.weaknesses && reportData.spellingAnalysis.weaknesses.length" class="report-weaknesses">
                                        <div class="weakness-label">不足：</div>
                                        <ul><li v-for="(w, i) in reportData.spellingAnalysis.weaknesses" :key="i">{{ w }}</li></ul>
                                    </div>
                                </el-card>
                                <el-card shadow="never" class="report-section" v-if="reportData.formChangeAnalysis">
                                    <div class="report-section-title">四、词形变化情况</div>
                                    <div class="report-general">{{ reportData.formChangeAnalysis.general }}</div>
                                    <div v-if="reportData.formChangeAnalysis.weaknesses && reportData.formChangeAnalysis.weaknesses.length" class="report-weaknesses">
                                        <div class="weakness-label">不足：</div>
                                        <ul><li v-for="(w, i) in reportData.formChangeAnalysis.weaknesses" :key="i">{{ w }}</li></ul>
                                    </div>
                                </el-card>
                                <el-card shadow="never" class="report-section" v-if="reportData.collocationAnalysis">
                                    <div class="report-section-title">五、固定搭配情况</div>
                                    <div class="report-general">{{ reportData.collocationAnalysis.general }}</div>
                                    <div v-if="reportData.collocationAnalysis.weaknesses && reportData.collocationAnalysis.weaknesses.length" class="report-weaknesses">
                                        <div class="weakness-label">不足：</div>
                                        <ul><li v-for="(w, i) in reportData.collocationAnalysis.weaknesses" :key="i">{{ w }}</li></ul>
                                    </div>
                                </el-card>
                                <el-card shadow="never" class="report-section report-suggestion" v-if="reportData.suggestion">
                                    <div class="report-section-title">综合建议</div>
                                    <div class="report-general">{{ reportData.suggestion }}</div>
                                </el-card>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div style="margin-top: 16px; display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
                        <el-button v-if="analyzePaper.paperStatus === 3" type="primary" :loading="confirmingGrading" @click="confirmAiResult">
                            确认批改结果
                        </el-button>
                        <el-button v-if="analyzePaper.paperStatus === 3 || analyzePaper.paperStatus === 4" type="warning" @click="handleRollbackGrading(analyzePaper.id)">
                            回退到已生成
                        </el-button>
                    </div>
                </template>
            </div>
            <div slot="footer">
                <el-button @click="analyzeDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 单词掌握管理弹窗 -->
        <el-dialog
            title="单词掌握管理"
            :visible.sync="masteryDialogVisible"
            width="700px"
            :close-on-click-modal="false">
            <div v-loading="masteryLoading">
                <el-alert
                    title="手动标记单词的掌握状态，已掌握的单词将在下次生成试卷时跳过"
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 20px;">
                </el-alert>

                <div class="mastery-count-bar">
                    <span>共 <strong>{{ masteryWords.length }}</strong> 个单词</span>
                    <span style="margin-left: 20px;">
                        已掌握 <strong class="count-mastered">{{ masteredCount }}</strong> 个
                    </span>
                    <span style="margin-left: 20px;">
                        未掌握 <strong class="count-unmastered">{{ masteryWords.length - masteredCount }}</strong> 个
                    </span>
                </div>

                <el-table
                    v-if="masteryWords.length > 0"
                    :data="masteryWords"
                    border
                    style="width: 100%; margin-top: 15px;"
                    max-height="400"
                    @row-click="toggleMasteryRow">
                    <el-table-column type="index" label="序号" width="60"/>
                    <el-table-column prop="word" label="单词" width="120"/>
                    <el-table-column prop="chineseMeaning" label="释义" width="200"/>
                    <el-table-column prop="phoneticUk" label="音标" width="140"/>
                    <el-table-column label="掌握状态" width="120">
                        <template slot-scope="scope">
                            <el-tag
                                :type="scope.row.isMastered ? 'success' : 'info'"
                                style="cursor: pointer;"
                                @click.stop="toggleMasteryRow(scope.row)">
                                <i :class="scope.row.isMastered ? 'el-icon-check' : 'el-icon-circle-close'"></i>
                                {{ scope.row.isMastered ? '已掌握' : '未掌握' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>

                <el-empty
                    v-if="masteryWords.length === 0 && !masteryLoading"
                    description="该学生暂无单词数据">
                </el-empty>
            </div>

            <div slot="footer">
                <el-button @click="masteryDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="masterySaving" @click="saveMastery">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    generatePaper,
    getStudentList,
    getPaperListByStudent,
    deletePaper as deletePaperApi, downloadPaperStream, downPaper2,
    getStudentPendingWords,
    reqQuestionTypes,
    reqPaperStatuses,
    reqWordMasteryDetails,
    reqBatchUpdateMastery,
    startAnswering,
    startGrading,
    reqAiDiagnosis,
    reqDiagnosisDetail,
    reqRollbackGrading
} from '@/api/education/assessment'
import { uploadFile, batchSaveAttachments, getAttachments } from '@/api/system/file'
import {reqGradeList} from '@/api/education/grade'
import {reqClassList} from '@/api/education/class'
import {reqVolumeOptions} from '@/api/education/unit'
import global from "@/api/global";

export default {
    name: 'StudentAssessment',
    data() {
        return {
            // 筛选表单
            filterForm: {
                gradeId: null,
                classId: null,
                nickname: '',
                studentNo: ''
            },

            // 年级和班级列表
            gradeList: [],
            classList: [],

            // 学生列表
            studentList: [],
            studentTotal: 0,
            studentPageSize: 10,
            studentCurrentPage: 1,

            // 选中的学生
            selectedStudent: null,

            // 试卷列表
            paperList: [],
            paperTotal: 0,
            paperPageSize: 10,
            paperCurrentPage: 1,
            paperLoading: false,
            paperSearchDate: null,
            paperSearchStatus: null,

            // 生成试卷对话框
            generateDialogVisible: false,
            generateStep: 1,
            generating: false,
            generateProgress: 0,
            generateProgressText: '',
            generateProgressStatus: '',

            // 题型列表
            questionTypes: [],
            selectedTypes: [], // [{type: 1, count: 1}, ...]

            // 单词列表
            pendingWords: [],
            selectedWordIds: [],
            loadingWords: false,

            // 是否为老师角色
            isTeacher: true,

            // 动态状态列表（从后端获取）
            statusList: [],
            statusTypeMap: { 0: 'info', 1: 'primary', 2: 'warning', 3: 'danger', 4: 'success' },

            // 答题并AI分析
            analyzeDialogVisible: false,
            analyzePaper: null,
            uploading: false,
            imagesSaved: false,
            savedAnswerImages: [],
            savedScreeningImages: [],
            analysisLoading: false,
            screeningLoading: false,
            diagnosisData: null,
            confirmingGrading: false,
            togglingWordId: null,

            // 单词掌握管理
            masteryDialogVisible: false,
            volumeNameList: [],  // 当前学生的分册名称列表（按顺序，如["上册","下册"]或["必修一","必修二"]）
            masteryWords: [],
            masteryLoading: false,
            masterySaving: false
        }
    },

    computed: {
        masteredCount() {
            return this.masteryWords.filter(w => w.isMastered).length
        },
        hasGradedPaper() {
            return this.paperList.some(p => p.score != null)
        },
        paperStatusSummary() {
            const map = {}
            this.statusList.forEach(s => { map[s.code] = 0 })
            this.paperList.forEach(p => { if (map[p.paperStatus] !== undefined) map[p.paperStatus]++ })
            return this.statusList.filter(s => map[s.code] > 0).map(s => ({ key: s.code, label: s.desc, type: this.statusTypeMap[s.code] || 'info', count: map[s.code] }))
        },
        studentNoDisplay() {
            return this.selectedStudent ? (this.selectedStudent.studentNo || '未设置') : ''
        },
        studentPaperCount() {
            return this.selectedStudent ? (this.selectedStudent.count != null ? this.selectedStudent.count : '-') : '-'
        },
        answerPreviewList() {
            return this.savedAnswerImages.map(img => img.url)
        },
        screeningPreviewList() {
            return this.savedScreeningImages.map(img => img.url)
        },
        reportData() {
            if (!this.diagnosisData || !this.diagnosisData.diagnosisResult) return null
            try {
                const parsed = typeof this.diagnosisData.diagnosisResult === 'string'
                    ? JSON.parse(this.diagnosisData.diagnosisResult)
                    : this.diagnosisData.diagnosisResult
                return {
                    studentName: this.diagnosisData.studentName || parsed.studentName || '',
                    reportDate: this.diagnosisData.reportDate || parsed.reportDate || '',
                    paperTitles: this.diagnosisData.paperTitles || parsed.paperTitles || [],
                    paperCount: this.diagnosisData.paperCount || parsed.paperCount || 0,
                    summary: parsed.summary || '',
                    vocabularyAnalysis: parsed.vocabularyAnalysis || null,
                    wordMeaningAnalysis: parsed.wordMeaningAnalysis || null,
                    spellingAnalysis: parsed.spellingAnalysis || null,
                    formChangeAnalysis: parsed.formChangeAnalysis || null,
                    collocationAnalysis: parsed.collocationAnalysis || null,
                    suggestion: parsed.suggestion || ''
                }
            } catch (e) {
                return null
            }
        }
    },

    created() {
        this.loadGradeList()
        this.loadStudents()
        this.loadPaperStatuses()
    },

    methods: {
        // 加载年级列表
        async loadGradeList() {
            try {
                const res = await reqGradeList()
                this.gradeList = res || []
            } catch (error) {
                console.error('加载年级列表失败:', error)
            }
        },

        // 年级变化时加载班级列表
        async handleGradeChange(gradeId) {
            this.filterForm.classId = null
            if (!gradeId) {
                this.classList = []
                return
            }

            try {
                const res = await reqClassList({gradeId})
                this.classList = res || []
            } catch (error) {
                console.error('加载班级列表失败:', error)
            }
        },

        // 加载学生列表
        async loadStudents() {
            try {
                const params = {
                    gradeId: this.filterForm.gradeId,
                    classId: this.filterForm.classId,
                    nickname: this.filterForm.nickname,
                    studentNo: this.filterForm.studentNo,
                    roleMark: 'STUDENT',
                    currentPage: 1,
                    pageSize: 500
                }
                const res = await getStudentList(params)

                // 根据实际返回格式解析数据
                let students = []
                if (res.data && res.data.records) {
                    students = res.data.records
                } else if (res.records) {
                    students = res.records
                } else if (Array.isArray(res)) {
                    students = res
                }

                // 为每个学生补充显示需要的字段
                this.studentList = students.map(student => ({
                    ...student,
                    username: student.nickName || student.username || student.userName || '',
                    studentNo: student.studentNo || '未设置',
                    gradeName: student.gradeName || '未知年级',
                    className: student.className || '未知班级'
                }))

                console.log('学生列表加载成功:', this.studentList.length, '人')
            } catch (error) {
                console.error('加载学生列表失败:', error)
                this.$message.error('加载学生列表失败')
            }
        },

        // 学生分页变化
        handleStudentPageChange(page) {
            this.studentCurrentPage = page
            this.loadStudents()
        },

        // 获取头像文字
        getAvatarText(username) {
            if (!username) return '?'
            // 钉钉风格：单字取首字，多字取后两个（如"张三"→"张三"，"欧阳娜娜"→"娜娜"）
            if (username.length === 1) return username.charAt(0).toUpperCase()
            return username.slice(-2)
        },

        // 根据分册编码获取分册标签文字（编码从1开始，对应 volumeNameList 索引）
        getVolumeLabel(code) {
            if (!code || code <= 0 || !this.volumeNameList || this.volumeNameList.length === 0) return '未知'
            const idx = code - 1
            return idx < this.volumeNameList.length ? this.volumeNameList[idx] : '未知'
        },

        // 获取头像颜色
        getAvatarColor(id) {
            const colors = [
                '#409eff', '#67c23a', '#e6a23c', '#f56c6c',
                '#9b59b6', '#1abc9c', '#e74c3c', '#3498db',
                '#2ecc71', '#f39c12', '#8e44ad', '#16a085'
            ]
            return colors[(id || 0) % colors.length]
        },

        // 学生选择（卡片点击）
        async handleStudentSelect(student) {
            if (!student) {
                this.selectedStudent = null
                this.studentProgress = null
                this.paperList = []
                this.paperTotal = 0
                return
            }

            this.selectedStudent = student
            // 加载该学生年级对应的分册名称列表
            this.volumeNameList = []
            if (student.gradeId) {
                try {
                    const res = await reqVolumeOptions(student.gradeId)
                    this.volumeNameList = (res && Array.isArray(res)) ? res : []
                } catch (e) {
                    console.error('加载分册选项失败:', e)
                }
            }
            this.paperCurrentPage = 1
            await this.loadPaperList()
        },

        // 加载试卷列表
        async loadPaperList() {
            if (!this.selectedStudent) return
            this.paperLoading = true
            try {
                const params = {
                    currentPage: this.paperCurrentPage,
                    pageSize: this.paperPageSize
                }
                if (this.paperSearchDate && this.paperSearchDate.length === 2) {
                    params.startDate = this.paperSearchDate[0]
                    params.endDate = this.paperSearchDate[1]
                }
                if (this.paperSearchStatus != null && this.paperSearchStatus !== '') {
                    params.paperStatus = this.paperSearchStatus
                }

                const res = await getPaperListByStudent(this.selectedStudent.id, params)
                this.paperList = res?.records || []
                this.paperTotal = res?.total || 0
            } catch (error) {
                this.$message.error('加载试卷列表失败')
            } finally {
                this.paperLoading = false
            }
        },

        // 试卷分页变化
        handlePaperPageChange(page) {
            this.paperCurrentPage = page
            this.loadPaperList()
        },
        handlePaperSizeChange(size) {
            this.paperPageSize = size
            this.paperCurrentPage = 1
            this.loadPaperList()
        },

        // 试卷筛选查询
        searchPapers() {
            this.paperCurrentPage = 1
            this.loadPaperList()
        },

        // 重置试卷筛选
        resetPaperFilter() {
            this.paperSearchDate = null
            this.paperSearchStatus = null
            this.paperCurrentPage = 1
            this.loadPaperList()
        },

        // 下拉菜单命令处理
        handlePaperCommand(command, row) {
            switch (command) {
                case 'qrcode':
                    this.reviewPaper(row.id)
                    break
                case 'detail':
                    this.viewPaperDetail(row.id)
                    break
                case 'analysis':
                    this.handleAnalyzeAndGrade(row)
                    break
                case 'rollback':
                    this.handleRollbackGrading(row.id)
                    break
            }
        },

        // 显示生成试卷对话框
        async showGenerateDialog() {
            this.generateStep = 1
            this.generateProgress = 0
            this.generateProgressText = ''
            this.selectedWordIds = []
            this.generateDialogVisible = true

            // 加载题型列表
            await this.loadQuestionTypes()
            // 加载待练习单词列表
            await this.loadPendingWords()
        },

        // 加载题型列表
        async loadQuestionTypes() {
            try {
                const res = await reqQuestionTypes()
                const list = res.data || res || []
                this.questionTypes = list
                // 固定题型 1-4 始终选中，使用后端返回的默认数量
                this.selectedTypes = list
                    .filter(item => item.code <= 4)
                    .map(item => ({ type: item.code, count: item.count || 1 }))
            } catch (error) {
                console.error('加载题型列表失败:', error)
                this.questionTypes = []
                this.selectedTypes = [1, 2, 3, 4].map(code => ({ type: code, count: 1 }))
            }
        },

        // 判断题型是否已选中
        isTypeSelected(code) {
            return this.selectedTypes.some(t => t.type === code)
        },

        // 获取题型配置对象
        getTypeConfig(code) {
            const found = this.selectedTypes.find(t => t.type === code)
            if (!found) {
                const newConfig = { type: code, count: 1 }
                this.selectedTypes.push(newConfig)
                return newConfig
            }
            return found
        },

        // 更新题型数量
        updateTypeCount(code, val) {
            const config = this.selectedTypes.find(t => t.type === code)
            if (config) config.count = val
        },

        // 切换题型选择
        toggleType(item) {
            if (item.code <= 4) return
            const idx = this.selectedTypes.findIndex(t => t.type === item.code)
            if (idx >= 0) {
                this.selectedTypes.splice(idx, 1)
            } else {
                this.selectedTypes.push({ type: item.code, count: item.count || 1 })
            }
        },

        // 加载待练习单词列表
        async loadPendingWords() {
            if (!this.selectedStudent) return

            this.loadingWords = true
            try {
                const res = await getStudentPendingWords(this.selectedStudent.id, {
                    limit: 8  // 预查询16个，实际选中8个
                })

                // 解析返回数据
                let words = []
                if (res.data) {
                    words = res.data
                } else if (Array.isArray(res)) {
                    words = res
                }

                this.pendingWords = words.map((word, index) => ({
                    ...word,
                    // 根据学习进度标记已掌握的单词
                    isMastered: index < (this.studentProgress?.totalWordsLearned || 0)
                }))

                // 自动勾选未掌握的单词（从已学习数量之后开始）
                const startIndex = this.studentProgress?.totalWordsLearned || 0
                const autoSelectCount = Math.min(8, this.pendingWords.length - startIndex)

                if (autoSelectCount > 0) {
                    this.selectedWordIds = this.pendingWords
                        .slice(startIndex, startIndex + autoSelectCount)
                        .map(w => w.id)
                }

                console.log('单词列表加载成功:', this.pendingWords.length, '个')
            } catch (error) {
                console.error('加载单词列表失败:', error)
                this.$message.error('加载单词列表失败')
                this.pendingWords = []
            } finally {
                this.loadingWords = false
            }
        },

        // 单词选择变化
        handleWordSelectionChange(selection) {
            this.selectedWordIds = selection.map(w => w.id)
        },

        // 判断单词是否可选择
        isWordSelectable(row) {
            // 已掌握的单词不可选择
            return !row.isMastered
        },

        // 确认生成试卷
        async confirmGenerate() {
            // 确保固定题型 1-4 始终包含
            const fixedConfigs = this.questionTypes
                .filter(item => item.code <= 4)
                .map(item => {
                    const existing = this.selectedTypes.find(t => t.type === item.code)
                    return { type: item.code, count: existing ? existing.count : (item.count || 1) }
                })
            const otherConfigs = this.selectedTypes.filter(t => t.type > 4)
            const finalConfigs = [...fixedConfigs, ...otherConfigs]

            if (finalConfigs.length === 0) {
                this.$message.warning('请至少选择一个题型')
                return
            }

            this.generating = true
            this.generateStep = 2
            this.updateProgress(10, '正在准备数据...')

            try {
                this.updateProgress(30, '正在调用AI生成内容...')

                const res = await generatePaper({
                    studentId: this.selectedStudent.id,
                    config: {
                        typeConfigs: finalConfigs
                    }
                })

                this.updateProgress(100, '生成完成！')

                this.generateDialogVisible = false
                this.generating = false
                await this.loadPaperList()
                this.$message.success('试卷生成成功')

            } catch (error) {
                this.$message.error('生成失败：' + (error.message || '未知错误'))
                this.generating = false
                this.generateStep = 1
            }
        },

        // 更新进度
        updateProgress(percent, text) {
            this.generateProgress = percent
            this.generateProgressText = text
        },

        // 下载试卷
        async downloadPaper(paperId) {
            try {
                const blob = await downloadPaperStream(paperId)
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = paperId + '.docx'
                document.body.appendChild(a)
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
            } catch (e) {
                this.$message.error('下载失败：' + (e.message || '未知错误'))
            }
        },
        async downloadPaper2(paperId) {
            this.$message.info('下载试卷：' + paperId)
            let data=await downPaper2(paperId);
        },

        // 删除失败的试卷
        async deletePaper(paperId) {
            try {
                await this.$confirm('确定要删除这份生成失败的试卷吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await deletePaperApi(paperId)
                this.$message.success('删除成功')
                this.loadPaperList()
            } catch (error) {
                if (error !== 'cancel') {
                    this.$message.error('删除失败：' + (error.message || '未知错误'))
                }
            }
        },

        // 继续答题
        continueAnswering(paperId) {
            this.$message.info('跳转到答题页面')
            // TODO: 路由跳转到答题页面
        },

        // 查看试卷详情
        viewPaperDetail(paperId) {
            this.$router.push({
                path: `/education/exam/assessment/detail/${paperId}`
            })
        },

        // 查看批改结果
        viewGradedPaper(paperId) {
            this.$message.info('查看批改结果')
            // TODO: 路由跳转到批改详情页面
        },

        // 开始批改
        async startGradingAction(paperId) {
            try {
                await this.$confirm('确定要开始批改这份试卷吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                this.$message.success('开始批改')
            } catch (error) {
                if (error !== 'cancel') {
                    console.error(error)
                }
            }
        },

        // 打开复习页面
        reviewPaper(paperId) {
            const url = this.$router.resolve({
                path: `/education/exam/assessment/review/${paperId}`
            })
            window.open(url.href, '_blank')
        },

            // 加载试卷状态列表（从后端获取）
        async loadPaperStatuses() {
            try {
                const res = await reqPaperStatuses()
                this.statusList = res.data || res || []
            } catch (error) {
                console.error('加载试卷状态列表失败:', error)
                this.statusList = [
                    { code: 0, desc: '生成中' }, { code: 1, desc: '已生成' },
                    { code: 2, desc: '生成失败' }, { code: 3, desc: '批改中' },
                    { code: 4, desc: '已批改' }
                ]
            }
        },

        // 获取状态文本
        getStatusText(status) {
            if (typeof status === 'string') return status
            const found = this.statusList.find(s => s.code === status)
            return found ? found.desc : '未知'
        },

        // 获取状态类型
        getStatusType(status) {
            if (typeof status === 'string') {
                const textTypeMap = { '生成中': 'info', '已生成': 'success', '生成失败': 'danger', '批改中': 'warning', '已批改': 'primary', '生成异常': 'warning' }
                return textTypeMap[status] || ''
            }
            const typeMap = {
                0: 'info',
                1: 'primary',
                2: 'warning',
                3: 'danger',
                4: 'success',
                5: 'warning'
            }
            return typeMap[status] || ''
        },

        // 从 missing_info(JSON) 解析"缺少xxx题目"摘要，用于列表"原因"列展示
        getMissingSummary(missingInfo) {
            if (!missingInfo) return ''
            try {
                const info = typeof missingInfo === 'string' ? JSON.parse(missingInfo) : missingInfo
                if (!info || !info.hasMissing || !info.items || !info.items.length) return ''
                return info.items
                    .map(it => `缺少${it.typeName}${it.missingCount || 0}篇`)
                    .join('；')
            } catch (e) {
                return ''
            }
        },

        // 答题并AI分析
        handleAnalyzeDialogClose() {
            this.loadPaperList()
        },

        async handleAnalyzeAndGrade(paper) {
            this.analyzePaper = JSON.parse(JSON.stringify(paper))
            this.imagesSaved = false
            this.diagnosisData = null
            this.savedAnswerImages = []
            this.savedScreeningImages = []
            this.analyzeDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.answerUploader) this.$refs.answerUploader.clearFiles()
                if (this.$refs.screeningUploader) this.$refs.screeningUploader.clearFiles()
            })
            await this.loadSavedImages(paper.id)
            await this.loadSavedDiagnosis(paper.id)
        },

        async loadSavedDiagnosis(paperId) {
            try {
                const res = await reqDiagnosisDetail(paperId)
                const data = res.data || res
                if (data && data.unmasteredWords) {
                    this.diagnosisData = data
                }
            } catch (e) {
                // 还没有诊断结果，忽略
            }
        },

        async loadSavedImages(paperId) {
            try {
                const [res1, res2] = await Promise.all([
                    getAttachments(paperId, 1),
                    getAttachments(paperId, 2)
                ])
                const list1 = (res1.data || res1 || []).map(item => ({ url: item.url, name: item.name }))
                const list2 = (res2.data || res2 || []).map(item => ({ url: item.url, name: item.name }))
                this.savedAnswerImages = list1
                this.savedScreeningImages = list2
                if (list1.length > 0 || list2.length > 0) {
                    this.imagesSaved = true
                }
            } catch (e) {
                // 忽略
            }
        },

        removeSavedAnswerImage(idx) {
            this.savedAnswerImages.splice(idx, 1)
            this.imagesSaved = this.savedAnswerImages.length > 0 || this.savedScreeningImages.length > 0
        },

        removeSavedScreeningImage(idx) {
            this.savedScreeningImages.splice(idx, 1)
            this.imagesSaved = this.savedAnswerImages.length > 0 || this.savedScreeningImages.length > 0
        },

        async saveImages() {
            const newAnswerFiles = this.$refs.answerUploader ? this.$refs.answerUploader.uploadFiles : []
            const newScreeningFiles = this.$refs.screeningUploader ? this.$refs.screeningUploader.uploadFiles : []
            const hasAnswer = newAnswerFiles.length > 0 || this.savedAnswerImages.length > 0
            const hasScreening = newScreeningFiles.length > 0 || this.savedScreeningImages.length > 0
            if (!hasAnswer && !hasScreening) {
                this.$message.warning('请选择至少一张图片')
                return
            }

            this.uploading = true
            try {
                const paperId = this.analyzePaper.id

                // 保存答题图片 (type=1)
                if (hasAnswer) {
                    const answerAttachments = this.savedAnswerImages.map(s => ({ url: s.url, name: s.name }))
                    for (const f of newAnswerFiles || []) {
                        const res = await uploadFile(f.raw)
                        const url = res.data || res.url || res
                        answerAttachments.push({ url, name: f.name })
                    }
                    await batchSaveAttachments(paperId, 1, answerAttachments)
                }

                // 保存筛查表图片 (type=2)
                if (hasScreening) {
                    const screeningAttachments = this.savedScreeningImages.map(s => ({ url: s.url, name: s.name }))
                    for (const f of newScreeningFiles || []) {
                        const res = await uploadFile(f.raw)
                        const url = res.data || res.url || res
                        screeningAttachments.push({ url, name: f.name })
                    }
                    await batchSaveAttachments(paperId, 2, screeningAttachments)
                }

                this.imagesSaved = true
                this.$message.success('图片保存成功')
            } catch (error) {
                this.$message.error('保存失败：' + (error.message || '未知错误'))
            } finally {
                this.uploading = false
            }
        },

        /** 仅筛查表解析：识别勾选单词，更新掌握状态 */
        async runScreeningAnalysis() {
            this.screeningLoading = true
            const loading = this.$loading({ lock: true, text: '筛查表解析中...', background: 'rgba(0,0,0,0.7)' })
            try {
                if (this.analyzePaper.paperStatus === 1) {
                    await startAnswering(this.analyzePaper.id)
                    this.analyzePaper.paperStatus = 3
                }
                const res = await reqAiDiagnosis({ paperId: this.analyzePaper.id, fileType: 2 })
                const data = res.data || res
                if (data) {
                    if (!data.masteredWords) data.masteredWords = []
                    if (!data.unmasteredWords) data.unmasteredWords = []
                    this.diagnosisData = data
                    this.$message.success(`筛查表解析完成：已掌握 ${data.masteredCount || 0} 个，未掌握 ${data.unmasteredCount || 0} 个`)
                }
            } catch (error) {
                this.$message.error('筛查表解析失败：' + (error.message || '未知错误'))
            } finally {
                loading.close()
                this.screeningLoading = false
            }
        },

        /** 答题分析：仅分析答题图片，生成学情报告 */
        async runAnswerAnalysis() {
            this.analysisLoading = true
            const loading = this.$loading({ lock: true, text: 'AI诊断分析中，请稍候...', background: 'rgba(0,0,0,0.7)' })
            try {
                if (this.analyzePaper.paperStatus === 1) {
                    await startAnswering(this.analyzePaper.id)
                    this.analyzePaper.paperStatus = 3
                }
                const res = await reqAiDiagnosis({ paperId: this.analyzePaper.id, fileType: 1 })
                const data = res.data || res
                if (data) {
                    if (!data.masteredWords) data.masteredWords = []
                    if (!data.unmasteredWords) data.unmasteredWords = []
                    this.diagnosisData = data
                    this.$message.success(`分析完成：已掌握 ${data.masteredCount || 0} 个，未掌握 ${data.unmasteredCount || 0} 个`)
                }
            } catch (error) {
                this.$message.error('分析失败：' + (error.message || '未知错误'))
            } finally {
                loading.close()
                this.analysisLoading = false
            }
        },

        /** 手动切换单个单词的掌握状态 */
        async toggleWordMastery(word, setMastered) {
            if (!word || !word.wordId) return
            this.togglingWordId = word.wordId
            try {
                await reqBatchUpdateMastery({
                    studentUserId: this.analyzePaper.studentUserId || this.selectedStudent.id,
                    words: [{ wordId: word.wordId, mastered: setMastered }]
                })
                // 更新本地数组
                const srcArray = setMastered ? 'unmasteredWords' : 'masteredWords'
                const dstArray = setMastered ? 'masteredWords' : 'unmasteredWords'
                const idx = this.diagnosisData[srcArray].findIndex(w => w.wordId === word.wordId)
                if (idx !== -1) {
                    const moved = this.diagnosisData[srcArray].splice(idx, 1)[0]
                    moved.diagnosisDetail = setMastered ? '手动标记已掌握' : '手动标记未掌握'
                    this.diagnosisData[dstArray].push(moved)
                }
                this.diagnosisData.masteredCount = this.diagnosisData.masteredWords.length
                this.diagnosisData.unmasteredCount = this.diagnosisData.unmasteredWords.length
                this.$message.success(`已标记"${word.word}"为${setMastered ? '已掌握' : '未掌握'}`)
            } catch (error) {
                this.$message.error('更新失败：' + (error.message || '未知错误'))
            } finally {
                this.togglingWordId = null
            }
        },

        async confirmAiResult() {
            this.confirmingGrading = true
            try {
                const teacherId = this.$store.state.user.id || 0
                await startGrading(this.analyzePaper.id, teacherId)
                this.$message.success('批改确认成功')
                this.analyzeDialogVisible = false
                this.loadPaperList()
            } catch (error) {
                this.$message.error('确认失败：' + (error.message || '未知错误'))
            } finally {
                this.confirmingGrading = false
            }
        },

        // 回退到已生成，允许重新上传和AI分析
        async handleRollbackGrading(paperId) {
            try {
                await this.$confirm('确定要回退到"已生成"状态吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqRollbackGrading(paperId)
                if (this.analyzePaper) this.analyzePaper.paperStatus = 1
                this.$message.success('已回退到已生成状态，旧结果仍可查看，重新分析后将覆盖')
                this.loadPaperList()
            } catch (error) {
                if (error !== 'cancel') {
                    this.$message.error('回退失败：' + (error.message || '未知错误'))
                }
            }
        },

        copyReport() {
            const r = this.reportData
            if (!r) return
            let text = `${r.studentName || ''} ${r.reportDate || ''}学情报告\n`
            text += `今日学案完成数量：${r.paperCount || 0}套\n`
            if (r.paperTitles && r.paperTitles.length) text += `试卷：${r.paperTitles.join('、')}\n`
            text += '\n'
            if (r.vocabularyAnalysis) {
                text += `一、词汇掌握情况\n${r.vocabularyAnalysis.general}\n`
                if (r.vocabularyAnalysis.weaknesses && r.vocabularyAnalysis.weaknesses.length) {
                    text += `不足：\n${r.vocabularyAnalysis.weaknesses.map(w => `- ${w}`).join('\n')}\n`
                }
                text += '\n'
            }
            if (r.wordMeaningAnalysis) {
                text += `二、词义理解情况\n${r.wordMeaningAnalysis.general}\n`
                if (r.wordMeaningAnalysis.weaknesses && r.wordMeaningAnalysis.weaknesses.length) {
                    text += `不足：\n${r.wordMeaningAnalysis.weaknesses.map(w => `- ${w}`).join('\n')}\n`
                }
                text += '\n'
            }
            if (r.spellingAnalysis) {
                text += `三、单词拼写情况\n${r.spellingAnalysis.general}\n`
                if (r.spellingAnalysis.weaknesses && r.spellingAnalysis.weaknesses.length) {
                    text += `不足：\n${r.spellingAnalysis.weaknesses.map(w => `- ${w}`).join('\n')}\n`
                }
                text += '\n'
            }
            if (r.formChangeAnalysis) {
                text += `四、词形变化情况\n${r.formChangeAnalysis.general}\n`
                if (r.formChangeAnalysis.weaknesses && r.formChangeAnalysis.weaknesses.length) {
                    text += `不足：\n${r.formChangeAnalysis.weaknesses.map(w => `- ${w}`).join('\n')}\n`
                }
                text += '\n'
            }
            if (r.collocationAnalysis) {
                text += `五、固定搭配情况\n${r.collocationAnalysis.general}\n`
                if (r.collocationAnalysis.weaknesses && r.collocationAnalysis.weaknesses.length) {
                    text += `不足：\n${r.collocationAnalysis.weaknesses.map(w => `- ${w}`).join('\n')}\n`
                }
                text += '\n'
            }
            if (r.suggestion) text += `综合建议\n${r.suggestion}\n`
            this.copyToClipboard(text)
        },

        copyToClipboard(text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message.success('学情报告已复制')
                }).catch(() => {
                    this.fallbackCopy(text)
                })
            } else {
                this.fallbackCopy(text)
            }
        },
        fallbackCopy(text) {
            const ta = document.createElement('textarea')
            ta.value = text
            ta.style.position = 'fixed'
            ta.style.left = '-9999px'
            document.body.appendChild(ta)
            ta.select()
            try {
                document.execCommand('copy')
                this.$message.success('学情报告已复制')
            } catch (e) {
                this.$message.error('复制失败，请手动复制')
            } finally {
                document.body.removeChild(ta)
            }
        },

        getActionTip(action, status) {
            if (action === 'download') {
                if (status === 0) return '试卷正在生成中'
                if (status === 2) return '试卷生成失败，无法下载'
                if (status === 3) return '批改中，无法下载'
                return ''
            }
            if (action === 'detail') {
                if (status === 0) return '试卷正在生成中'
                if (status === 2) return '试卷已失败'
                return ''
            }
            if (action === 'delete') {
                if (status === 0) return '试卷正在生成中'
                if (status === 3 || status === 4) return '试卷无法删除'
                return ''
            }
            return ''
        },

        // 重置筛选
        resetFilter() {
            this.filterForm = {
                gradeId: null,
                classId: null,
                nickname: '',
                studentNo: ''
            }
            this.classList = []
            this.loadStudents()
        },

        formatTime(time) {
            if (!time) return '-'
            const d = new Date(time)
            const pad = n => String(n).padStart(2, '0')
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
        },

        scoreClass(row) {
            if (row.score == null || row.totalScore == null) return ''
            const ratio = row.score / row.totalScore
            if (ratio >= 0.8) return 'score-excellent'
            if (ratio >= 0.6) return 'score-pass'
            return 'score-fail'
        },

        handleAction(cmd, row) {
            const actions = {
                download: () => this.downloadPaper(row.id),
                detail: () => this.viewPaperDetail(row.id),
                delete: () => this.deletePaper(row.id),
                continue: () => this.continueAnswering(row.id),
                graded: () => this.viewGradedPaper(row.id),
                review: () => this.reviewPaper(row.id),
            }
            if (actions[cmd]) actions[cmd]()
        },

        handleExpandChange(row, expandedRows) {
        },

        // 显示单词掌握管理弹窗
        async showMasteryDialog() {
            if (!this.selectedStudent) {
                this.$message.warning('请先选择一个学生')
                return
            }
            this.masteryDialogVisible = true
            this.masteryLoading = true
            try {
                const res = await reqWordMasteryDetails(this.selectedStudent.id)
                const data = res?.data || res || []
                this.masteryWords = (Array.isArray(data) ? data : []).map(item => ({
                    ...item,
                    isMastered: item.isMastered === true
                }))
            } catch (error) {
                console.error('加载单词掌握详情失败:', error)
                this.$message.error('加载单词数据失败')
                this.masteryWords = []
            } finally {
                this.masteryLoading = false
            }
        },

        // 点击行切换掌握状态
        toggleMasteryRow(row) {
            row.isMastered = !row.isMastered
        },

        // 保存单词掌握状态
        async saveMastery() {
            this.masterySaving = true
            try {
                const words = this.masteryWords.map(w => ({
                    wordId: w.id,
                    mastered: w.isMastered
                }))
                await reqBatchUpdateMastery({
                    studentUserId: this.selectedStudent.id,
                    words
                })
                this.$message.success('保存成功')
                this.masteryDialogVisible = false
            } catch (error) {
                console.error('保存单词掌握状态失败:', error)
                this.$message.error(error?.message || '保存失败')
            } finally {
                this.masterySaving = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.assessment-page {
    .filter-card,
    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                margin-right: 6px;
                color: #409EFF;
            }

            .el-divider {
                margin: 0 10px;
                background-color: #dcdfe6;
            }

            .header-sub {
                font-weight: 400;
                font-size: 13px;
                color: #909399;
            }
        }
    }

    .filter-form {
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
    }

.student-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 0;
    background: #fff;
    height: calc(100vh - 220px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    overflow: hidden;

    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    ::v-deep .el-scrollbar__bar.is-horizontal {
        display: none;
    }

    .list-header {
        padding: 14px 18px;
        border-bottom: 1px solid #e4e7ed;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fafbfc;

        h3 {
            margin: 0;
            font-size: 15px;
            color: #303133;
            font-weight: 600;
        }

        .count-badge {
            background: #e8edf3;
            color: #606266;
            padding: 1px 10px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 500;
        }
    }
}

.student-card {
    display: flex;
    align-items: center;
    padding: 12px 18px;
    border-bottom: 1px solid #f2f3f5;
    cursor: pointer;
    transition: background 0.2s;
    background: #fff;
    position: relative;

    &:hover {
        background: #f5f7fa;

        .card-arrow {
            opacity: 1;
            transform: translateX(0);
        }
    }

    &.active {
        background: #ecf5ff;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 4px;
            bottom: 4px;
            width: 3px;
            background: #409eff;
            border-radius: 0 2px 2px 0;
        }

        .card-arrow {
            opacity: 1;
            color: #409eff;
        }
    }

    .student-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 600;
        margin-right: 12px;
        flex-shrink: 0;
        letter-spacing: 1px;
    }

    .student-info {
        flex: 1;
        min-width: 0;

        .student-name {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .student-meta {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 12px;
            color: #909399;

            .meta-item {
                display: flex;
                align-items: center;
                gap: 2px;

                i {
                    font-size: 12px;
                }

                &.meta-warn {
                    color: #f56c6c;
                    font-weight: 600;

                    i {
                        color: #f56c6c;
                    }
                }
            }

            .meta-divider {
                color: #dcdfe6;
                margin: 0 4px;
            }
        }

        .student-meta-secondary {
            margin-top: 3px;
        }
    }

    .card-arrow {
        font-size: 14px;
        color: #c0c4cc;
        opacity: 0;
        transform: translateX(-4px);
        transition: all 0.2s;
        margin-left: 8px;
    }
}

    .empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 400px;
    }

    .paper-management {
        .student-info-bar {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 14px 20px;
            background: #ecf5ff;
            border-radius: 8px;
            border: 1px solid #d9ecff;

            .student-info-avatar {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                flex-shrink: 0;
                letter-spacing: 1px;
            }

            .student-info-content {
                flex: 1;
                min-width: 0;

                .info-name {
                    font-size: 15px;
                    font-weight: 600;
                    color: #303133;
                    margin-bottom: 6px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .info-row {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 8px;

                    .info-tag {
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        font-size: 12px;
                        color: #606266;
                        background: #fff;
                        padding: 2px 10px;
                        border-radius: 12px;
                        border: 1px solid #e4e7ed;

                        i {
                            font-size: 12px;
                            color: #909399;
                        }
                    }
                }
            }

            .student-info-stats {
                display: flex;
                align-items: center;
                gap: 0;
                flex-shrink: 0;

                .stat-item {
                    text-align: center;
                    padding: 0 18px;

                    .stat-value {
                        display: block;
                        font-size: 22px;
                        font-weight: 700;
                        color: #409eff;
                        line-height: 1.2;
                        transition: color 0.3s;

                        &.stat-warn {
                            color: #f56c6c;
                            animation: stat-pulse 2s ease-in-out infinite;
                        }
                    }

                    @keyframes stat-pulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.6; }
                    }

                    .stat-label {
                        display: block;
                        font-size: 11px;
                        color: #909399;
                        margin-top: 2px;
                    }
                }

                .stat-divider {
                    width: 1px;
                    height: 32px;
                    background: #d9ecff;
                }
            }
        }

        .action-bar {
            padding: 12px 0;
            margin-top: 12px;
            border-bottom: 1px solid #ebeef5;
        }

        .paper-filter-bar {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 12px 0;
            border-bottom: 1px solid #ebeef5;
        }

        .paper-list-container {
            margin-top: 16px;

            .paper-list-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12px;

                h3 {
                    margin: 0;
                    font-size: 15px;
                    color: #303133;
                    font-weight: 600;
                }

                .total-badge {
                    font-size: 13px;
                    color: #606266;

                    b {
                        color: #409EFF;
                    }
                }
            }
        }
    }
}

.paper-detail-preview {
    padding: 16px 24px;
    background: #f8f9fb;

    .detail-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;

        .detail-item {
            .label {
                display: block;
                font-size: 12px;
                color: #909399;
                margin-bottom: 4px;
            }

            .val {
                font-size: 14px;
                color: #303133;
                font-weight: 500;

                .correct { color: #67c23a; font-weight: 600; }
                .wrong { color: #f56c6c; font-weight: 600; }
            }
        }
    }
}

.paper-info-cell {
    .paper-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .paper-meta {
        display: flex;
        gap: 8px;
        margin-bottom: 6px;

        .meta-tag {
            font-size: 12px;
            color: #909399;
            background: #f0f2f5;
            padding: 0 6px;
            border-radius: 3px;
            line-height: 20px;
        }
    }

    .paper-types {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }
}

.type-tag {
    display: inline-block;
    font-size: 11px;
    padding: 1px 7px;
    border-radius: 10px;
    line-height: 18px;
    font-weight: 500;
    white-space: nowrap;
}
.type-color-1 { background: #ecf5ff; color: #409eff; border: 1px solid #d9ecff; }
.type-color-2 { background: #f0f9eb; color: #67c23a; border: 1px solid #e1f3d8; }
.type-color-3 { background: #fdf6ec; color: #e6a23c; border: 1px solid #faecd8; }
.type-color-4 { background: #fef0f0; color: #f56c6c; border: 1px solid #fde2e2; }
.type-color-5 { background: #f5f0ff; color: #7c3aed; border: 1px solid #ede9fe; }

.score-value {
    font-size: 16px;
    font-weight: 700;
}
.score-excellent { color: #67c23a; }
.score-pass { color: #e6a23c; }
.score-fail { color: #f56c6c; }

.no-score {
    color: #c0c4cc;
}

.time-cell {
    font-size: 13px;
    color: #606266;
    line-height: 1.6;

    i { margin-right: 4px; }

    .time-label {
        display: inline-block;
        font-size: 11px;
        color: #909399;
        background: #f0f2f5;
        padding: 0 5px;
        border-radius: 3px;
        margin-right: 4px;
    }
}

.generate-info {
    padding: 15px;
    background: #f5f7fa;
    border-radius: 4px;

    .info-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;

        .info-item {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .label {
                font-size: 12px;
                color: #909399;
            }

            .val {
                font-size: 14px;
                color: #303133;
                font-weight: 500;
            }
        }
    }
}

.word-selection-section {
    margin-top: 20px;

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        h4 {
            margin: 0;
            font-size: 15px;
            color: #303133;
            font-weight: 600;
        }

        .selection-info {
            font-size: 14px;
            color: #606266;

            .count-highlight {
                color: #409eff;
                font-size: 18px;
                font-weight: bold;
                margin: 0 4px;
            }
        }
    }
}

.type-selection-section {
    margin-top: 20px;

    .section-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;

        h4 {
            margin: 0;
            font-size: 15px;
            color: #303133;
            font-weight: 600;
        }

        .selection-info {
            font-size: 12px;
            color: #909399;
        }
    }

    .type-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .type-chip {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 8px 14px;
            border: 1px solid #dcdfe6;
            border-radius: 20px;
            cursor: pointer;
            transition: all 0.2s ease;
            background: #fff;
            user-select: none;
            min-width: 160px;
            box-sizing: border-box;

            &:hover:not(.fixed) {
                border-color: #409eff;
                background: #ecf5ff;
            }

            &.selected {
                border-color: #409eff;
                background: #ecf5ff;
                color: #409eff;
            }

            &.fixed {
                border-color: #dcdfe6;
                background: #f5f7fa;
                cursor: not-allowed;
                color: #909399;

                .type-code {
                    background: #a0a4a8;
                }

                .el-icon-lock {
                    color: #c0c4cc;
                    font-size: 12px;
                }
            }

            .type-code {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                background: #c0c4cc;
                color: #fff;
                font-size: 12px;
                font-weight: 600;
                flex-shrink: 0;
            }

            &.selected .type-code,
            &.fixed .type-code {
                background: #409eff;
            }

            .type-desc {
                font-size: 13px;
                flex-shrink: 0;
            }

            .type-count-input {
                display: inline-flex;
                align-items: center;
                gap: 2px;
                margin-left: 4px;

                .count-label {
                    font-size: 11px;
                    color: #909399;
                    white-space: nowrap;
                }

                .el-input-number--mini {
                    width: 80px;

                    .el-input-number__increase,
                    .el-input-number__decrease {
                        width: 18px;
                        font-size: 11px;
                    }

                    .el-input__inner {
                        padding-left: 20px;
                        padding-right: 20px;
                        height: 22px;
                        line-height: 22px;
                        font-size: 11px;
                    }
                }
            }

            .check-placeholder {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 14px;
                height: 14px;
                margin-left: auto;

                .el-icon-check {
                    color: #409eff;
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }
    }
}

.generating-step {
    text-align: center;
    padding: 20px;

    p {
        margin: 15px 0;
        font-size: 16px;
        color: #303133;
    }

    .progress-text {
        font-size: 14px;
        color: #909399;
    }
}

.action-btns {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}

.image-section {
    .image-section-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;

        .image-section-label {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
        }

        .image-section-hint {
            font-size: 12px;
            color: #909399;
        }
    }
}

.saved-images-bar {
    .saved-images-title {
        font-size: 13px;
        color: #909399;
        margin-bottom: 8px;
    }

    .saved-images-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .saved-image-item {
            position: relative;
            width: 100px;
            height: 100px;
            border-radius: 6px;
            overflow: hidden;
            border: 1px solid #e4e7ed;

            .el-image {
                width: 100%;
                height: 100%;
            }

            .saved-image-remove {
                position: absolute;
                top: 4px;
                right: 4px;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.5);
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-size: 12px;
                opacity: 0;
                transition: opacity 0.2s;

                &:hover {
                    background: rgba(245, 108, 108, 0.8);
                }
            }

            &:hover .saved-image-remove {
                opacity: 1;
            }
        }
    }
}

.mastery-count-bar {
    font-size: 14px;
    color: #606266;
    padding: 12px 16px;
    background: #f5f7fa;
    border-radius: 4px;

    strong { font-size: 16px; }
    .count-mastered { color: #67c23a; }
    .count-unmastered { color: #f56c6c; }
}

.type-group-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 6px;
    .type-group-count {
        font-size: 12px;
        color: #909399;
    }
}

/* ========== 学情报告样式 ========== */
.report-container {
    max-height: 500px;
    overflow-y: auto;
    padding: 4px;
}

.report-header {
    text-align: center;
    padding: 16px 0 12px;
    border-bottom: 2px solid #409eff;
    margin-bottom: 16px;

    h2 {
        margin: 0;
        font-size: 20px;
        color: #303133;
        font-weight: 700;
    }
}

.report-section {
    margin-bottom: 12px;
    border: 1px solid #e4e7ed !important;
    border-radius: 6px !important;

    .report-section-title {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
        margin-bottom: 8px;
    }

    .report-general {
        font-size: 13px;
        color: #606266;
        line-height: 1.7;
        white-space: pre-wrap;
    }

    .report-weaknesses {
        margin-top: 8px;
        padding: 8px 12px;
        background: #fef0f0;
        border-radius: 4px;

        .weakness-label {
            font-size: 13px;
            font-weight: 600;
            color: #f56c6c;
            margin-bottom: 4px;
        }

        ul {
            margin: 0;
            padding-left: 18px;

            li {
                font-size: 13px;
                color: #606266;
                line-height: 1.6;
                margin-bottom: 2px;
            }
        }
    }
}

.report-suggestion {
    border-left: 3px solid #e6a23c !important;

    .report-section-title {
        color: #e6a23c;
    }

    .report-general {
        color: #856404;
    }
}

.report-paper-titles {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;

    .paper-title-tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 10px;
        border-radius: 12px;
        background: #ecf5ff;
        color: #409eff;
        border: 1px solid #d9ecff;
    }
}

.screening-section-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 0;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 8px;
}

.upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 120px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    color: #c0c4cc;
    font-size: 14px;
    gap: 8px;
    background: #fafafa;

    i {
        font-size: 28px;
    }
}

// 表格统一样式
::v-deep .el-table {
    th.el-table__cell {
        background-color: #fafafa;
        color: #606266;
        font-weight: 600;
    }
}

// 对话框统一样式
.el-dialog {
    ::v-deep .el-dialog {
        border-radius: 6px;

        .el-dialog__header {
            padding: 18px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
            }
        }

        .el-dialog__body {
            padding: 24px;
        }

        .el-dialog__footer {
            padding: 14px 24px;
            border-top: 1px solid #ebeef5;
        }
    }
}

@media (max-width: 768px) {
    .filter-card,
    .table-card {
        margin: 8px 6px;
    }
}
</style>
